import { useQuery } from "@tanstack/react-query";

import {
  type CxcValidationFilters,
  cxcValidationService,
} from "~/services/contabilidad/cxcValidationService";

export const CXC_VALIDATION_QUERY_KEY = ["cxc-validation"];

export function useCxcValidation(filters: CxcValidationFilters) {
  return useQuery({
    queryKey: [...CXC_VALIDATION_QUERY_KEY, filters],
    queryFn: () => cxcValidationService.getCxcMovementValidation(filters),
    enabled: !!filters.initialDate && !!filters.finalDate,
  });
}
